import { useDispatch, useSelector } from "react-redux";

import {
  Alert,
  AlertTitle,
  Button,
  Dialog,
  DialogActions,
  DialogTitle
} from "@common";

import { clearSessionExpired, isSessionExpired } from "@session";

import {
  setShowErrorAlert,
  setShowErrorAlertMessage,
} from "@features";

const ShowErrorAlert = (props) => {
  const myProject = useSelector((state) => state?.myProject);
  const dispatch = useDispatch();

  const handleClose = () => {
    const shouldRedirect = isSessionExpired(); 
    dispatch(setShowErrorAlert(false));
    dispatch(setShowErrorAlertMessage(""));
    if (shouldRedirect) { 
      clearSessionExpired(); 
        globalThis.location.replace("/"); 
    } 
  };

  return (
    <div>
      <Dialog
        open={myProject?.showErrorAlert}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            handleClose();
          }
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="error-dialog-title">
          <Alert severity="error">
            <AlertTitle>{myProject?.showErrorAlertMessage}</AlertTitle>
          </Alert>
        </DialogTitle>
        {/* <DialogContent>
          <Typography id="error-dialog-description">
            {myProject?.showErrorAlertMessage}
          </Typography>
        </DialogContent> */}

        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus={true}>
            Close
          </Button>
          {/* <Button onClick={handleClose} color="primary" autoFocus>
            OK
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ShowErrorAlert;
